const filterCompanies = (filter, items) => {
    return [...items].filter(company => isCompanyMatchesFilter(company, filter))
}

function isCompanyMatchesFilter(company, filter) {
    const keys = Object.keys(filter)
        .filter(key => key in company)
        .map(key => key)

    return keys.every(key => {
        const filterValue = filter[key]
        if (filterValue === undefined) return true

        const companyValue = company[key]
        const filterValueUpper = filterValue.toUpperCase()

        const isValueNumeric = /^-?\d+$/.test(filterValue)
        const isLicensesFilter = ["userLicenses", "catalogLicenses"].includes(key)

        if (isLicensesFilter) {
            const isUserLicensesFilter = key === "userLicenses"
            const usedLicenses = String(
                company[isUserLicensesFilter ? "users" : "catalogs"].length
            )

            if (!isValueNumeric) {
                if (isUserLicensesFilter) {
                    return company.unlimitedUserLicenses
                } else {
                    return company.unlimitedCatalogLicenses
                }
            }

            const isUnlimited =
                company[
                isUserLicensesFilter
                    ? "unlimitedUserLicenses"
                    : "unlimitedCatalogLicenses"
                ]
            if (isUnlimited) {
                return usedLicenses.includes(filterValue)
            }

            const result = String(companyValue).includes(filterValue)
            if (result) {
                return result
            }

            return usedLicenses.includes(filterValue)
        }

        if (!Array.isArray(companyValue)) {
            const companyValueUpper = String(companyValue).toUpperCase()
            return companyValueUpper.includes(filterValueUpper)
        }

        return companyValue.some(item => {
            if (key === "users" && "fullName" in item) {
                return item.fullName.toUpperCase().includes(filterValueUpper)
            }

            if (key === "catalogs" && "name" in item) {
                return item.name.toUpperCase().includes(filterValueUpper)
            }

            throw new Error(`Invalid filter key: ${key}`)
        })
    })
}

export default filterCompanies
